"use strict";
/**
 * Self Serve Plugin
 * using prototypal pattern for object
 * using pub/sub for communication
 * using extend for namespace
 * using inherit for inheritance
 * using factory pattern for object creation
 * using singleton pattern for controlling the instance
 * version: 1.0
 */

const MTF_SSM = (function () {
    return {
        defualt: {},
        inherit: (parent, child) => {
            const Fn = function () {};
            Fn.prototype = parent.prototype;
            const obj = new Fn();
            child.prototype = obj;
            child.prototype.constructor = child;
        },
        extend: function (n, t) {
            var r = n.split("."),
                i = this;
            $(r).each(function (n, u) {
                typeof i[u] == "undefined" &&
                    ((i[u] = {}), n + 1 === r.length && (i[u] = t));
                i = i[u];
            });
        },
        throttle: function (func, limit) {
            let inThrottle;
            return function (...args) {
                const context = this;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    setTimeout(() => (inThrottle = false), limit);
                }
            };
        },
        debounce: function (func, delay) {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), delay);
            };
        },
        convertCompactNumber: function (num) {
            if (typeof num !== "string") return num;
            switch (num.substr(-1).toLowerCase()) {
                case "m":
                    return num.substr(0, num.length - 1) * 1000000;
                case "k":
                    return num.substr(0, num.length - 1) * 1000;
                default:
                    return num * 1;
            }
        },
    };
})();

MTF_SSM.extend(
    "utils.eventBus",
    (function () {
        const events = {};
        return {
            subscribe: function (event, listener) {
                if (!events[event]) {
                    events[event] = [];
                }
                events[event].push(listener);
            },
            publish: function (event, data) {
                if (events[event]) {
                    events[event].forEach((listener) => listener(data));
                }
            },
        };
    })()
);

MTF_SSM.extend(
    "baseManager",
    (function () {
        function BaseManager() {
            this.errorTmpl =
                "<div class='error toast'><span id='toastMessage'></span><span id='closeToast'><img src='https://www.monotypefonts-beta.com/cdn/shop/files/icon-close-white.svg?v=3141409769310123521'/></span></div>";
            this.initialize();
        }
        BaseManager.prototype = {
            initialize: function () {
                $("body").append(this.errorTmpl);
                this.$errorEl = $(".error.toast");
                this.$messageEl = $("#toastMessage");
                this.$closeToast = $("#closeToast");
                this.initializeListeners();
            },
            publishEvent: function (event, payload) {
                MTF_SSM.utils.eventBus.publish(event, payload);
            },
            showError: function (message, callback) {
                this.$messageEl.text(message);
                this.$errorEl.addClass("show");
                this.callback = callback;
                setTimeout(() => {
                    this.$errorEl.removeClass("show");
                    callback && callback();
                }, 3000);
            },
            initializeListeners: function () {
                this.$closeToast.on("click", () => {
                    this.$errorEl.removeClass("show");
                    this.callback && this.callback();
                });
            },
        };
        return BaseManager;
    })()
);

MTF_SSM.extend(
    "addOnFeature",
    (function () {
        function AddOnFeature(element, options) {
            this.jElement = $(element);
            this.options = $.extend(customSelectors, options);
            this.currentVariantDetails =
                this.options.currentVariantDetails ?? null;

            this.availableVariants = this.jElement.data("variants")
                ? this.jElement.data("variants")?.variants
                : [];
            this.init();
        }
        const customSelectors = {
            addOnValueContainer: ".add-on-value",
            addOnIncrementer: ".add-on-incrementer",
            addOnDecrementer: ".add-on-decrementer",
            addOnAnimationWrapper: "#addon-animation-container",
        };
        AddOnFeature.prototype = {
            init: function () {
                this.$addOnValueContainer = this.jElement.find(
                    this.options.addOnValueContainer
                );
                this.$addOnIncrementer = this.jElement.find(
                    this.options.addOnIncrementer
                );
                this.$addOnDecrementer = this.jElement.find(
                    this.options.addOnDecrementer
                );
                this.$addOnAnimationWrapper = this.jElement.find(
                    this.options.addOnAnimationWrapper
                );
                this.setUpDataAttributes();
                if (!this.availableVariants || !this.availableVariants.length) {
                    console.log("No variants available");
                    this.$addOnIncrementer.prop("disabled", true);
                    this.$addOnDecrementer.prop("disabled", true);
                }
                this.addListeners();
            },
            setUpDataAttributes: function () {
                this.minValue = Number(this.jElement.data("min-value"));
                this.currentValue = this.currentVariantDetails
                    ? Number(
                          MTF_SSM.convertCompactNumber(
                              this.currentVariantDetails.variantTitle
                          )
                      ) + this.minValue
                    : this.minValue;
                this.jElement.data("current-value", this.currentValue);
                this.$addOnValueContainer.text(this.currentValue);

                if (this.currentValue <= this.minValue) {
                    this.$addOnDecrementer.prop("disabled", true);
                }
            },
            showAnimation: function (value = 0) {
                const animationElement = document.createElement("div");
                animationElement.classList.add("addon-animation");
                animationElement.textContent = `+${value}`;
                this.$addOnAnimationWrapper.append(animationElement);
                setTimeout(() => {
                    animationElement.remove();
                }, 1000);
            },
            //{variantTitle:"",productHandle:"", variantId:"", variantPrice:"", variantQuantity:"", cartPropName:""}
            stepIncrementAndDecrement: function (operation) {
                try {
                    if (operation === "increment") {
                        if (!this.currentVariantDetails) {
                            this.currentVariantDetails =
                                this.availableVariants[0];
                            this.currentValue =
                                Number(this.minValue) +
                                Number(
                                    this.currentVariantDetails.variantQuantity
                                ) *
                                    Number(
                                        MTF_SSM.convertCompactNumber(
                                            this.currentVariantDetails
                                                .variantTitle
                                        )
                                    );
                        } else if (this.currentVariantDetails) {
                            const currentVariantIndex =
                                this.availableVariants.findIndex(
                                    (variant) =>
                                        Number(variant.variantId) ===
                                        Number(
                                            this.currentVariantDetails.variantId
                                        )
                                );
                            if (
                                currentVariantIndex ===
                                this.availableVariants.length - 1
                            ) {
                                this.$addOnIncrementer.prop("disabled", true);
                            }
                            this.currentVariantDetails =
                                this.availableVariants[currentVariantIndex + 1];

                            this.currentValue =
                                Number(this.minValue) +
                                this.currentVariantDetails.variantQuantity *
                                    Number(
                                        MTF_SSM.convertCompactNumber(
                                            this.currentVariantDetails
                                                .variantTitle
                                        )
                                    );
                            if (
                                currentVariantIndex + 1 >=
                                this.availableVariants.length - 1
                            ) {
                                this.$addOnIncrementer.prop("disabled", true);
                            }
                        }
                        this.options.publishEvent("increment", {
                            ...this.currentVariantDetails,
                        });
                        console.log(
                            "Current Variant",
                            this.currentVariantDetails
                        );
                        // this.showAnimation(
                        //     this.currentVariantDetails?.variantTitle
                        // );
                    } else {
                        if (this.currentVariantDetails) {
                            const currentVariantIndex =
                                this.availableVariants.findIndex(
                                    (variant) =>
                                        Number(variant.variantId) ===
                                        Number(
                                            this.currentVariantDetails.variantId
                                        )
                                );
                            if (currentVariantIndex === 0) {
                                this.$addOnDecrementer.prop("disabled", true);
                            } else if (currentVariantIndex >= 0) {
                                this.$addOnIncrementer.prop("disabled", false);
                            }
                            this.currentVariantDetails =
                                this.availableVariants[currentVariantIndex - 1];
                            this.currentValue = this.currentVariantDetails
                                ? Number(this.minValue) +
                                  Number(
                                      this.currentVariantDetails.variantQuantity
                                  ) *
                                      Number(
                                          MTF_SSM.convertCompactNumber(
                                              this.currentVariantDetails
                                                  .variantTitle
                                          )
                                      )
                                : Number(this.minValue);
                            this.options.publishEvent("decrement", {
                                ...this.currentVariantDetails,
                                productHandle:
                                    this.availableVariants[0].productHandle,
                            });
                        }
                        // this.showAnimation(
                        //     this.currentVariantDetails?.variantTitle
                        // );
                        console.log(
                            `Current Variant(${this.availableVariants[0].productHandle})`,
                            this.currentVariantDetails ?? "variant removed"
                        );
                    }
                } catch (err) {
                    console.error(err);
                }
            },
            incrementValue: function () {
                this.stepIncrementAndDecrement("increment");
                this.$addOnValueContainer.text(this.currentValue);
                this.jElement.data("current-value", this.currentValue);
                this.$addOnDecrementer.prop("disabled", false);
            },
            decrementValue: function () {
                this.stepIncrementAndDecrement("decrement");
                this.$addOnValueContainer.text(this.currentValue);
                this.jElement.data("current-value", this.currentValue);
                if (this.currentValue <= this.minValue) {
                    this.$addOnDecrementer.prop("disabled", true);
                }
            },
            addListeners: function () {
                this.$addOnIncrementer.on(
                    "click",
                    this.incrementValue.bind(this)
                );
                this.$addOnDecrementer.on(
                    "click",
                    this.decrementValue.bind(this)
                );
            },
        };
        return AddOnFeature;
    })()
);

MTF_SSM.extend(
    "addOnManager",
    (function () {
        function AddOnManager(jElement, options) {
            MTF_SSM.baseManager.call(this);
            this.jElement = jElement;
            this.options = $.extend(customSelectors, options);
            this.addOns = [];
            this.basePlan = this.jElement.data("base-plan");
            console.log("Base Plan", this.basePlan);
            this.basePrice = Number(this.basePlan?.price ?? 0);
            this.sellingPlanId = this.jElement.data("selling-plan-id");
            this.init();
        }
        const customSelectors = {
            customAddOnWrapper: ".add-on-wrapper .custom.add-on",
            planSummaryContainer: ".plan-summary-wrapper",
            stickyPlanSummaryContainer: ".sticky-plan-summary",
            stickyPlanSummaryText: ".content .left > span",
            stickyPlanSummaryPrice: ".content .right .price",
            subscribeButton: "button.subscribe",
            customizeAddOnsButton: ".customize-addons",
            addOnSection: ".mt-comparison-table",
            tryForFreeCta: ".tooltip-container > a",
        };
        MTF_SSM.inherit(MTF_SSM.baseManager, AddOnManager);
        Object.assign(AddOnManager.prototype, {
            init: function () {
                this.customAddOnWrappers = this.jElement.find(
                    this.options.customAddOnWrapper
                );
                this.$addOnSection = this.jElement.find(
                    this.options.addOnSection
                );
                this.$planSummaryContainer = this.jElement.find(
                    this.options.planSummaryContainer
                );
                this.$stickyPlanSummaryContainer = this.jElement.find(
                    this.options.stickyPlanSummaryContainer
                );
                this.$stickyPlanSummaryText =
                    this.$stickyPlanSummaryContainer.find(
                        this.options.stickyPlanSummaryText
                    );
                this.basePlanText = this.$stickyPlanSummaryText.text();
                this.$stickyPlanSummaryPrice =
                    this.$stickyPlanSummaryContainer.find(
                        this.options.stickyPlanSummaryPrice
                    );
                this.$subscribeButton = this.jElement.find(
                    this.options.subscribeButton
                );
                this.$customizeAddOnsButton = this.jElement.find(
                    this.options.customizeAddOnsButton
                );
                this.$tryForFreeCta = this.jElement.find(
                    this.options.tryForFreeCta
                );
                $.each(this.customAddOnWrappers, (_index, element) => {
                    new MTF_SSM.addOnFeature(element, {
                        publishEvent: this.publishEvent,
                    });
                });
                this.addListeners();
                this.handleScroll();
                MTF_SSM.utils.eventBus.subscribe(
                    "increment",
                    this.handleIncrement.bind(this)
                );
                MTF_SSM.utils.eventBus.subscribe(
                    "decrement",
                    this.handleDecrement.bind(this)
                );
            },
            handleScroll: function (e) {
                const el = this.$planSummaryContainer[0];
                const rect = el.getBoundingClientRect();
                if (rect.bottom <= 330) {
                    this.$stickyPlanSummaryContainer.addClass("show");
                } else {
                    this.$stickyPlanSummaryContainer.removeClass("show");
                }
            },
            calculateTotalPrice: function () {
                const currencySymbol = this.$stickyPlanSummaryPrice
                    ?.text()
                    .charAt(0);
                if (!currencySymbol) return;
                if (this.addOns.length) {
                    this.$stickyPlanSummaryText.text(
                        `${this.basePlanText} + ${this.addOns.length} add on`
                    );
                } else {
                    this.$stickyPlanSummaryText.text(this.basePlanText);
                }
                let totalPrice = Number(this.basePrice);
                this.addOns.forEach((addOn) => {
                    totalPrice += Number(addOn.variantPrice);
                });
                this.$stickyPlanSummaryPrice?.text(
                    `${currencySymbol}${totalPrice}`
                );
            },
            handleIncrement: function (data) {
                console.log("Event received increment", data);
                if (!this.addOns.length) {
                    this.addOns.push(data);
                } else {
                    const index = this.addOns.findIndex(
                        (addOn) => addOn.productHandle === data.productHandle
                    );
                    if (index === -1) {
                        this.addOns.push(data);
                    } else {
                        // splice the array and update the new data
                        this.addOns.splice(index, 1, data);
                    }
                }
                console.log("Addons", this.addOns);
                this.calculateTotalPrice();
            },
            handleDecrement: function (data) {
                console.log("Event received decrement", data);
                if (data.variantId) {
                    // can't remove the element from the array
                    this.addOns = this.addOns.map((addOn) => {
                        if (addOn.productHandle === data.productHandle) {
                            return { ...data };
                        }
                        return addOn;
                    });
                } else {
                    this.addOns = this.addOns.filter(
                        (addOn) => addOn.productHandle !== data.productHandle
                    );
                }
                console.log("Addons", this.addOns);
                this.calculateTotalPrice();
            },
            handleSubscribe: function () {
                // need to build quick checkout link from addons and then redirect
                // EX:  https://sonakshi-monotype.myshopify.com/cart/clear?return_to=/cart/add?items[0][id]=44487759888543&items[0][quantity]=1&items[0][selling_plan]=1023967391&items[1][id]=43069897670815&items[1][quantity]=1&items[1][selling_plan]=1023967391&return_to=%2Fcheckout%3F
                const baseUrl = currentLocale === 'pt' ? `${window.location.origin}/pt/cart/clear?return_to=` : `${window.location.origin}/cart/clear?return_to=`;
                let items = this.addOns.concat(this.basePlan);
                let quickCheckoutParams = `/cart/add?`;
                items.forEach((item, index) => {
                    quickCheckoutParams += `items[${index}][id]=${item.variantId}&items[${index}][quantity]=1&items[${index}][selling_plan]=${this.sellingPlanId}`;
                    if (index < items.length - 1) {
                        quickCheckoutParams += "&";
                    }
                });
                quickCheckoutParams += currentLocale === 'pt' ? `&return_to=/pt/cart` : `&return_to=/cart`;
                quickCheckoutParams = encodeURIComponent(quickCheckoutParams);
                let finalUrl = `${baseUrl}${quickCheckoutParams}`;
                window.location.href = finalUrl;
            },
            handleCustomize: function () {
                const targetElement = this.$addOnSection[0];
                if (targetElement) {
                    const offset = 200;
                    const targetPosition =
                        targetElement.getBoundingClientRect().top +
                        window.scrollY;
                    window.scrollTo({
                        top: targetPosition - offset,
                        behavior: "smooth",
                    });
                }
            },
            handleTooltipShow: function () {
                const tooltip = document.querySelector(
                    ".trial-tooltip-wrapper"
                );
                tooltip.classList.add("show");
            },
            handleTooltipHide: function () {
                const tooltip = document.querySelector(
                    ".trial-tooltip-wrapper"
                );
                tooltip.classList.remove("show");
            },
            addListeners: function () {
                const debouncedScroll = MTF_SSM.debounce(
                    this.handleScroll.bind(this),
                    100
                );
                $(window).scroll(debouncedScroll);
                this.$subscribeButton.on(
                    "click",
                    this.handleSubscribe.bind(this)
                );
                this.$customizeAddOnsButton.on(
                    "click",
                    this.handleCustomize.bind(this)
                );
                this.$tryForFreeCta.on(
                    "mouseenter",
                    this.handleTooltipShow.bind(this)
                );
                this.$tryForFreeCta.on(
                    "mouseleave",
                    this.handleTooltipHide.bind(this)
                );
            },
        });

        return AddOnManager;
    })()
);

MTF_SSM.extend(
    "cartManager",
    (function () {
        function CartManager(jElement, options) {
            MTF_SSM.addOnManager.call(this, jElement, {
                incrementerTmpl:
                    "<button class='add-on-incrementer'><svg class='icon' width='16' height='16'><use xlink:href='#icon-incrementer'></use></svg></button>",
                decrementerTmpl:
                    "<button class='add-on-decrementer'><svg class='icon' width='16' height='16'><use xlink:href='#icon-decrementer'></use></svg></button>",
                loaderTmpl: `
                    <svg class="spinner-container" width="22px" height="22px" viewBox="0 0 52 52">
                        <circle class="path" cx="26px" cy="26px" r="20px" fill="none" stroke-width="5px"></circle>
                    </svg>
                `,
                cartProperties: ".cart-product-feature-title",
                cartPropertyValues: ".cart-product-value-title",
                incrementers: "button[class*=add-on]",
                cartSummary: ".cart-summary",
                syncCartButtons: ".cart-summary-login-button",
                downloadQuoteButton: ".cart-options > .btn-download",
                popUpCloseButton: ".pop-up-close"
            });
            this.isCartSynced = true;
            this.validToken = false;
        }
        MTF_SSM.inherit(MTF_SSM.addOnManager, CartManager);
        Object.assign(CartManager.prototype, {
            init: function () {
                console.log("=========== cartManager initialized ===========");
                this.addOns = [];
                this.$syncCartButtons = this.jElement.find(
                    this.options.syncCartButtons
                );
                this.$downloadQuoteButton = this.jElement.find(
                    this.options.downloadQuoteButton
                );
                this.$cartProperties = this.jElement.find(
                    this.options.cartProperties
                );
                this.$cartBellBdge = $(".l-cart-value");
                this.$popUpCloseButton = this.jElement.find(
                    this.options.popUpCloseButton
                );
                // initialize cart summary manager
                new MTF_SSM.cartSummaryManager(
                    this.jElement.find(this.options.cartSummary)
                );

                this.setUpIncrementers();
                MTF_SSM.utils.eventBus.subscribe(
                    "increment",
                    this.handleIncrement.bind(this)
                );
                MTF_SSM.utils.eventBus.subscribe(
                    "decrement",
                    this.handleDecrement.bind(this)
                );
                this.getCartDetails().then((cartDetails) => {
                    this.previousProperties = cartDetails.items[0]?.properties;
                });
                this.addListeners();
            },
            setUpIncrementers: async function () {
                // populate addons from cart detail
                const cartDetails = await this.getCartDetails();
                cartDetails.items.splice(0, 1);
                this.addOns = cartDetails.items.map((item) => {
                    return {
                        variantId: item.variant_id,
                        variantPrice: item.presentment_price,
                        variantTitle: item.variant_title,
                        variantQuantity: item.quantity,
                        productHandle: item.handle,
                        cartPropName: this.basePlan.features.find(
                            (feature) => feature.handle === item.handle
                        )?.cartPropName,
                    };
                });
                this.customAddOnWrapper = this.$cartProperties.filter(
                    (_i, propEl) => {
                        let attrTitle = $(propEl).data("cart-prop");
                        attrTitle = attrTitle.trim();
                        // needs to be checked on base plan's configurable addOns
                        return this.basePlan?.features.find(
                            (addOn) => addOn.cartPropName === attrTitle
                        );
                    }
                );
                this.customAddOnWrapper.each((_i, propEl) => {
                    const $propEl = $(propEl);
                    const currentCartPropName = $propEl.data("cart-prop");
                    const $propValueEl = $propEl.find(
                        this.options.cartPropertyValues
                    );
                    const currentVariantDetails = this.addOns?.find((addOn) => {
                        return addOn.cartPropName === currentCartPropName;
                    });

                    const $incrementer = $(this.options.incrementerTmpl);
                    const $decrementer = $(this.options.decrementerTmpl);
                    $propValueEl.after($incrementer);
                    $propValueEl.before($decrementer);
                    // each feature should have available variants populated in data-variants
                    const feature =
                        this.getVariantsForAddOn(currentCartPropName);

                    $(propEl).data("variants", feature);
                    $(propEl).data("min-value", feature.defaultValue);

                    new MTF_SSM.addOnFeature(propEl, {
                        publishEvent: this.publishEvent,
                        currentVariantDetails: currentVariantDetails ?? null,
                    });
                });
                this.$incrementers = this.jElement.find(
                    this.options.incrementers
                );
            },
            getVariantsForAddOn: function (prop) {
                const feature = this.basePlan?.features.find(
                    (feature) => feature.cartPropName === prop
                );
                return feature;
            },
            reEnableIncrementers: function () {
                // need to iterate over all incrementers and enable them
                this.$incrementers.each((_i, btn) => {
                    const $parentEl = $(btn).closest(
                        ".cart-product-feature-title"
                    );
                    const $currentValueEl = $parentEl.find(
                        ".cart-product-value-title"
                    );
                    const feature = this.basePlan.features.find(
                        (feature) =>
                            feature.cartPropName === $parentEl.data("cart-prop")
                    );
                    const currentValue = $currentValueEl.text();
                    // get class name
                    if ($(btn).hasClass("add-on-incrementer")) {
                        // increment operation
                        $(btn).prop("disabled", false);
                        // in case we have reached max variant incrementer needs to stay disabled
                    } else {
                        if (
                            MTF_SSM.convertCompactNumber(currentValue) >
                            MTF_SSM.convertCompactNumber(feature.defaultValue)
                        ) {
                            $(btn).prop("disabled", false);
                        }
                    }
                });
            },
            handleIncrement: function (data) {
                const { productHandle } = data;
                console.log("==== Event received increment in cart ====", data);
                MTF_SSM.addOnManager.prototype.handleIncrement.call(this, data);
                this.updateCartState(productHandle, "increment");
            },
            handleDecrement: function (data) {
                const { productHandle } = data;
                console.log("==== Event received decrement in cart ====", data);
                MTF_SSM.addOnManager.prototype.handleDecrement.call(this, data);
                this.updateCartState(productHandle, "decrement");
            },
            clearCart: async function () {
                try {
                    const response = await fetch("/cart/clear.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });
                    if (!response.ok) throw new Error("Failed to clear cart");
                    console.log("Cart cleared");
                } catch (error) {
                    console.log(error);
                    throw new Error("Failed to clear cart");
                }
            },
            getCartDetails: async function () {
                try {
                    const response = await fetch("/cart.js", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });
                    if (!response.ok)
                        throw new Error("Failed to get cart details");
                    return response.json();
                } catch (err) {
                    throw err;
                }
            },
            animateCartBadge: function (itemsCount = 1) {
                this.$cartBellBdge.text(itemsCount);
                this.$cartBellBdge.addClass("animate");
                setTimeout(() => {
                    this.$cartBellBdge.removeClass("animate");
                }, 1500);
            },
            syncCartState: async function () {
                await this.clearCart();
                let basePlan = {
                    id: this.basePlan.variantId,
                    quantity: 1,
                    selling_plan: this.sellingPlanId,
                };
                const addOns = this.addOns.map((addOn) => {
                    return {
                        id: addOn.variantId,
                        quantity: 1,
                        selling_plan: this.sellingPlanId,
                    };
                });
                const items = [...addOns, basePlan];
                const addResponse = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ items }),
                });
                if (!addResponse.ok) throw new Error("ADD_TO_CART_FAILED");
                const updateResponse = await fetch(`/cart/change.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: basePlan.id,
                        properties: this.previousProperties,
                    }),
                });
                if (!updateResponse.ok) throw new Error("UPDATE_CART_FAILED");
                this.isCartSynced = true;
                this.animateCartBadge(items.length);
                console.log("Cart updated successfully");
            },
            updateCartState: function (currentAddOnHandle, operationType) {
                try {
                    let properties = {};
                    if (operationType === "increment") {
                        properties = {
                            ...this.previousProperties,
                            ...this.addOns.reduce((acc, addOn) => {
                                const feature = this.basePlan.features.find(
                                    (feature) =>
                                        feature.cartPropName ===
                                        addOn.cartPropName
                                );

                                // Create a key-value pair where the key is the cartPropName
                                acc[addOn.cartPropName] =
                                    MTF_SSM.convertCompactNumber(
                                        feature.defaultValue
                                    ) +
                                    Number(
                                        MTF_SSM.convertCompactNumber(
                                            addOn.variantTitle
                                        )
                                    );

                                return acc;
                            }, {}),
                        };
                    } else {
                        const modifiedAddOn = this.addOns.find(
                            (addOn) =>
                                addOn.productHandle === currentAddOnHandle
                        );
                        // find feature in base plan for default value
                        const feature = this.basePlan.features.find(
                            (feature) => feature.handle === currentAddOnHandle
                        );
                        if (modifiedAddOn) {
                            properties = {
                                ...this.previousProperties,
                                [modifiedAddOn.cartPropName]:
                                    MTF_SSM.convertCompactNumber(
                                        feature.defaultValue
                                    ) +
                                    Number(
                                        MTF_SSM.convertCompactNumber(
                                            modifiedAddOn.variantTitle
                                        )
                                    ),
                            };
                        } else {
                            properties = {
                                ...this.previousProperties,
                                [feature.cartPropName]:
                                    MTF_SSM.convertCompactNumber(
                                        feature.defaultValue
                                    ),
                            };
                        }
                    }
                    this.previousProperties = properties;
                    MTF_SSM.utils.eventBus.publish("cartUpdate", {
                        properties,
                        basePlan: this.basePlan,
                    });
                } catch (err) {
                    this.showError(
                        `An error occurred while updating your cart. We're resetting it to the previous state.`,
                        () => {
                            window.location.href = window.location.href;
                        }
                    );
                } finally {
                    this.isCartSynced = false;
                }
            },
            validateAccessToken: async function () {
                try {
                    if(!window.customerEmail) {
                      return;
                    }
                    const authToken = "Bearer " + atob(access_token);
                    const url = auth0UserInfoUrl || "https://monotypeidp.us.auth0.com/userinfo";
                    const response = await fetch(url, {
                    method: "GET",
                    headers: {
                        Authorization: authToken,
                    },
                    });

                    if (!response.ok) {
                    localStorage.setItem("validAccessToken", "false");
                    } else {
                    this.validToken = true;
                    }
                } catch (error) {
                    localStorage.setItem("validAccessToken", "false");
                    console.error("Error fetching user info:", error);
                }
            },
            handleContinue: async function (e) {
                const previousText = this.$syncCartButtons.text();
                try {
                    this.$syncCartButtons.html(this.options.loaderTmpl);
                    if(!this.validToken) await this.validateAccessToken();
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.isCartSynced) {
                        return window.cartCheckout();
                    }
                    await this.syncCartState();
                    window.cartCheckout();
                } catch (err) {
                    const message =
                        err.message === "ADD_TO_CART_FAILED"
                            ? "An error occurred while updating your cart. We're resetting it to the previous state."
                            : "An error occurred while updating your cart. We're resetting it to the base plan.";
                    this.showError(message, () => {
                        if (err.message === "ADD_TO_CART_FAILED") {
                            window.location.href = window.location.href;
                        } else {
                            this.addOns = [];
                            this.handleSubscribe();
                        }
                    });
                } finally {
                    if(!this.validToken) {
                        this.$syncCartButtons.text(log_in_text_custom || "Logging in ...");
                        return;
                    }
                    this.$syncCartButtons.text(previousText);
                }
            },
            trapFocus: function trapFocus(modalSelector) {
                const modal = document.querySelector(modalSelector);
                if (!modal) return;

                const getFocusableElements = () => {
                    const selectors = [
                        'span.pop-up-close.pop-up-cross',
                        'a[download="license.pdf"]',
                        'div.pop-up-content',
                        'button#cart-consent-close',
                        'button#agreeButton'
                    ];

                    return Array.from(modal.querySelectorAll(selectors.join(',')))
                        .filter(el => {
                            const style = getComputedStyle(el);
                            const isVisible = style.display !== "none" && style.visibility !== "hidden";
                            const isDisabled = el.disabled || el.getAttribute('aria-disabled') === "true";
                            return isVisible && !isDisabled;
                        });
                };

                function handleKeydown(e) {
                    const focusableElements = getFocusableElements();
                    const firstElement = focusableElements[0];
                    const lastElement = focusableElements[focusableElements.length - 1];

                    if (e.key === "Tab" || e.keyCode === 9) {
                        if (e.shiftKey) {
                            if (document.activeElement === firstElement) {
                                e.preventDefault();
                                lastElement.focus();
                            }
                        } else {
                            if (document.activeElement === lastElement) {
                                e.preventDefault();
                                firstElement.focus();
                            }
                        }
                    } else if (e.key === "Escape" || e.keyCode === 27) {
                        modal.style.display = "none";
                    }
                }

                modal.removeEventListener('keydown', handleKeydown);
                modal.addEventListener('keydown', handleKeydown);
            },
            handleQuoteDownload: async function (e) {
                try {
                    this.$downloadQuoteButton.prop("disabled", true);
                    const eulaUrl = `${window.location.protocol}//${
                        window.location.hostname
                    }${currentLocale == 'pt' ? '/pt' : ''}/pages/eula?eulablockid=${
                        MTF_CART.eulaVersion.split("$$")[1]
                    }`;
                    if (!this.isCartSynced) {
                        await this.syncCartState();
                    }
                    const response = await this.getCartDetails();
                    const apiResponse = await fetch(
                        `${backendApiUrl}api/price-quote`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                cartData: response ?? cartdata,
                                customerEmail,
                                eulaUrl: eulaUrl,
                                locale: currentLocale
                            }),
                        }
                    );
                    if (!apiResponse.ok) {
                        throw new Error("DOWNLOAD_FAILED");
                    }
                    const blob = await apiResponse.blob();
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style.display = "none";
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = "price-quote.pdf";
                    a.click();
                    a.remove();
                } catch (err) {
                    console.error(err);
                    this.showError(
                        "An error occurred while downloading the price quote. Please try again later."
                    );
                } finally {
                    this.$downloadQuoteButton.prop("disabled", false);
                }
            },
            addListeners: function () {
                this.$syncCartButtons.on(
                    "click",
                    this.handleContinue.bind(this)
                );
                this.$syncCartButtons.on("keydown", (e) => {
                    if (e.key === "Enter" || e.keyCode === 13) {
                        this.handleContinue(e);

                        setTimeout(() => {
                            const $closeBtn = document.querySelector(".pop-up-large .pop-up-close");
                            if ($closeBtn) {
                                $closeBtn.focus();
                                this.trapFocus(".pop-up-large");
                            }
                        }, 1000);
                    }
                });
                this.$popUpCloseButton.on("keydown", (e) => {
                    if (e.key === "enter" || e.keyCode === 13) {
                        this.$syncCartButtons.focus();
                    }
                });
                this.$downloadQuoteButton.on(
                    "click",
                    this.handleQuoteDownload.bind(this)
                );
            },
        });
        return CartManager;
    })()
);

MTF_SSM.extend(
    "cartSummaryManager",
    (function () {
        function CartSummaryManager(jElement, options) {
            this.jElement = jElement;
            this.options = $.extend(customSelectors, options);
            MTF_SSM.utils.eventBus.subscribe(
                "cartUpdate",
                this.handleCartUpdate.bind(this)
            );
            this.init();
        }
        const customSelectors = {
            addOnFeatureInSummary: ".cart-summary-product-features.addon",
            baseFeatureInSummary: ".cart-summary-product-features.base",
            totalPriceSelector: ".cart-summary-footer .cart-total-price",
            addOnTotalPriceSelector: ".cart-summary-add-on-price",
            cartSummaryItemContainer: ".cart-summary-item",
            cartFeatureTitleWrapper:
                ".cart-summary-product-feature-title-wrapper",
            addOnText: window.cart_summary_addon_msg,
            seatsDisplayText: window.seats_display_text,
        };
        CartSummaryManager.prototype = {
            init: function () {
                this.$baseFeatureContainer = this.jElement.find(
                    this.options.baseFeatureInSummary
                );
                this.$addOnSummaryContainer = this.jElement.find(
                    this.options.addOnFeatureInSummary
                );
                this.$addOnSummaryContainer = this.$addOnSummaryContainer.length
                    ? this.$addOnSummaryContainer
                    : null;
                this.$totalPrice = this.jElement.find(
                    this.options.totalPriceSelector
                );
                this.$addOnTotalPrice = this.jElement.find(
                    this.options.addOnTotalPriceSelector
                );
                this.$cartSummaryItemContainer = this.jElement.find(
                    this.options.cartSummaryItemContainer
                );
            },
            injectFeatureTitle: function (
                $featureTitleWrapper,
                cartPropName,
                value
            ) {
                let featureHTML = `
                <div class="cart-summary-product-feature-title">
                    <div class="cart-summary-product-feature-title-inner">
                        <span>${cartPropName}</span>
                    </div>
                    <div class="cart-summary-product-value">
                        <span class="cart-summary-product-value-title">+${value}</span>
                    </div>
                </div>`;
                $featureTitleWrapper.append(featureHTML);
            },
            injectTemplate: function (filteredProperties, basePlan) {
                try {
                    const currencySymbol = this.$totalPrice.text().charAt(0);
                    if (!filteredProperties || !filteredProperties.length) {
                        this.$addOnSummaryContainer?.remove();
                        this.$totalPrice.text(
                            `${currencySymbol}${basePlan.price}`
                        );
                        this.$addOnSummaryContainer = null;
                    } else {
                        if (!this.$addOnSummaryContainer) {
                            // first time add the container, need to modify the clone and make it addOnSummaryContainer
                            this.$addOnSummaryContainer =
                                this.$baseFeatureContainer.clone(true, true);
                            this.$addOnSummaryContainer.removeClass("base");
                            this.$addOnSummaryContainer.addClass("addon");
                            const $featureTitleWrapper =
                                this.$addOnSummaryContainer.find(
                                    this.options.cartFeatureTitleWrapper
                                );
                            const $featureText =
                                this.$addOnSummaryContainer.find(
                                    ".cart-summary-product-features-text"
                                );
                            $featureText.text(this.options.addOnText);
                            $featureTitleWrapper.empty();
                            // Need to add the properties in the container
                            filteredProperties.forEach((property) => {
                                const { cartPropName, value, handle } =
                                    property;
                                this.injectFeatureTitle(
                                    $featureTitleWrapper,
                                    handle.includes("seats")
                                        ? this.options.seatsDisplayText
                                        : cartPropName,
                                    value
                                );
                            });

                            this.$addOnTotalPrice =
                                this.$addOnSummaryContainer.find(
                                    ".cart-summary-product-price"
                                );
                            // this.$totalPrice = this.$addOnSummaryContainer.find(
                            //     this.options.totalPriceSelector
                            // );
                            this.$cartSummaryItemContainer.append(
                                this.$addOnSummaryContainer
                            );
                        } else {
                            // need to reinstate cause it may have been emptied
                            this.$totalPrice = this.jElement.find(
                                this.options.totalPriceSelector
                            );
                            // rerender the container with the properties
                            const $featureTitleWrapper =
                                this.$addOnSummaryContainer.find(
                                    this.options.cartFeatureTitleWrapper
                                );
                            $featureTitleWrapper.empty();
                            filteredProperties.forEach((property) => {
                                const { cartPropName, value, handle } =
                                    property;
                                this.injectFeatureTitle(
                                    $featureTitleWrapper,
                                    handle.includes("seats")
                                        ? this.options.seatsDisplayText
                                        : cartPropName,
                                    value
                                );
                            });
                        }

                        const addOnTotalPrice = filteredProperties.reduce(
                            (acc, property) => {
                                const handle = property.handle;
                                const feature = basePlan.features.find(
                                    (feature) => feature.handle === handle
                                );
                                const variantPrice = feature.variants.find(
                                    (variant) =>
                                        MTF_SSM.convertCompactNumber(
                                            variant.variantTitle
                                        ) ===
                                        MTF_SSM.convertCompactNumber(
                                            property.value
                                        )
                                )?.variantPrice;
                                return acc + Number(variantPrice);
                            },
                            0
                        );
                        this.$addOnTotalPrice.text(
                            `${currencySymbol}${addOnTotalPrice}`
                        );
                        const totalPrice =
                            Number(addOnTotalPrice) + Number(basePlan.price);
                        this.$totalPrice.text(`${currencySymbol}${totalPrice}`);
                    }
                } catch (err) {
                    console.error(err);
                }
            },
            handleCartUpdate: function (data) {
                const { basePlan, properties } = data;
                const filteredProperties = basePlan.features
                    .filter((feature, _i) => {
                        if (feature.variants && feature.variants.length) {
                            // find this feature in properties and return if the default value in feature is less than the value in properties
                            return (
                                MTF_SSM.convertCompactNumber(
                                    properties[feature.cartPropName]
                                ) >
                                MTF_SSM.convertCompactNumber(
                                    feature.defaultValue
                                )
                            );
                        }
                    })
                    .map((feature) => {
                        return {
                            cartPropName: feature.cartPropName,
                            value:
                                MTF_SSM.convertCompactNumber(
                                    properties[feature.cartPropName]
                                ) -
                                MTF_SSM.convertCompactNumber(
                                    feature.defaultValue
                                ),
                            handle: feature.handle,
                        };
                    });
                this.injectTemplate(filteredProperties, basePlan);
                // animate the cart price
                // this.$totalPrice.addClass("animate");
                // setTimeout(() => {
                //     this.$totalPrice.removeClass("animate");
                // }, 1500);
            },
        };
        return CartSummaryManager;
    })()
);
// SingletonFactory using IIFE
const SingletonFactory = (function () {
    const instances = {}; // Object to store singleton instances

    return {
        getInstance: function (type, jElement, options = {}) {
            if (!instances[type]) {
                switch (type) {
                    case "Cart":
                        instances[type] = new MTF_SSM.cartManager(
                            jElement,
                            options
                        );
                        break;
                    case "AddOn":
                        instances[type] = new MTF_SSM.addOnManager(
                            jElement,
                            options
                        );
                        break;
                    default:
                        throw new Error("Unknown manager type");
                }
            }
            return instances[type];
        },
    };
})();

$(document).ready(function () {
    // Get single instances using the factory
    const $addOnWrapper = $(".plan-wrapper");
    const $cartWrapper = $(".cart-wrapper");
    if ($addOnWrapper.length) {
        SingletonFactory.getInstance("AddOn", $addOnWrapper);
    } else if ($cartWrapper.length) {
        SingletonFactory.getInstance("Cart", $cartWrapper);
    }
});
